var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_774_7866",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_774_7866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7334 8.8667L9.76675 7.90003C9.86675 7.37781 9.71675 6.88892 9.31675 6.43337C8.91675 5.97781 8.40008 5.80003 7.76675 5.90003L6.80008 4.93337C6.98897 4.84448 7.18064 4.77781 7.37508 4.73337C7.56953 4.68892 7.77786 4.6667 8.00008 4.6667C8.83342 4.6667 9.54175 4.95837 10.1251 5.5417C10.7084 6.12503 11.0001 6.83337 11.0001 7.6667C11.0001 7.88892 10.9779 8.09726 10.9334 8.2917C10.889 8.48614 10.8223 8.67781 10.7334 8.8667ZM12.8667 10.9667L11.9001 10.0334C12.3223 9.71114 12.6973 9.35837 13.0251 8.97503C13.3529 8.5917 13.6334 8.15559 13.8667 7.6667C13.3112 6.54448 12.514 5.65281 11.4751 4.9917C10.4362 4.33059 9.27786 4.00003 8.00008 4.00003C7.67786 4.00003 7.36119 4.02225 7.05008 4.0667C6.73897 4.11114 6.43341 4.17781 6.13341 4.2667L5.10008 3.23337C5.55564 3.04448 6.0223 2.90281 6.50008 2.80837C6.97786 2.71392 7.47786 2.6667 8.00008 2.6667C9.67786 2.6667 11.1723 3.13059 12.4834 4.05837C13.7945 4.98614 14.7445 6.18892 15.3334 7.6667C15.0779 8.32226 14.7417 8.93059 14.3251 9.4917C13.9084 10.0528 13.4223 10.5445 12.8667 10.9667ZM13.2001 15.0667L10.4001 12.3C10.0112 12.4223 9.61953 12.5139 9.22508 12.575C8.83064 12.6361 8.4223 12.6667 8.00008 12.6667C6.3223 12.6667 4.82786 12.2028 3.51675 11.275C2.20564 10.3473 1.25564 9.14448 0.666748 7.6667C0.900081 7.07781 1.19453 6.53059 1.55008 6.02503C1.90564 5.51948 2.31119 5.0667 2.76675 4.6667L0.933415 2.80003L1.86675 1.8667L14.1334 14.1334L13.2001 15.0667ZM3.70008 5.60003C3.37786 5.88892 3.08341 6.20559 2.81675 6.55003C2.55008 6.89448 2.3223 7.2667 2.13341 7.6667C2.68897 8.78892 3.48619 9.68059 4.52508 10.3417C5.56397 11.0028 6.7223 11.3334 8.00008 11.3334C8.2223 11.3334 8.43897 11.3195 8.65008 11.2917C8.86119 11.2639 9.07786 11.2334 9.30008 11.2L8.70008 10.5667C8.57786 10.6 8.46119 10.625 8.35008 10.6417C8.23897 10.6584 8.1223 10.6667 8.00008 10.6667C7.16675 10.6667 6.45842 10.375 5.87508 9.7917C5.29175 9.20837 5.00008 8.50003 5.00008 7.6667C5.00008 7.54448 5.00841 7.42781 5.02508 7.3167C5.04175 7.20559 5.06675 7.08892 5.10008 6.9667L3.70008 5.60003Z",
    fill: "#5F6376"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility_off.b63697d0d5bc86da595102fcea37c4f8.svg";
export { ForwardRef as ReactComponent };